import React, { useEffect, useState } from 'react';
import { firestore } from '../firebase/firebase';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {
  // BrowserRouter as Router,
  // useHistory
} from "react-router-dom";

import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
  root: {
    '& div.MuiDataGrid-row': {
      cursor: 'pointer',
    },
  },
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  searchForm: {
    width: '100%',
    marginBottom: 40
  },
  searchInput: {
    width: '50%'
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 30,
    // textAlign: 'left',
  },
}));



function ClosedDays() {

  const [timestamps, setTimestamps] = useState([]);

  useEffect(() => {
    const init = async () => {
      await getClosedDays();
    };
    init();
  }, []);

  const getClosedDays = async () => {

    try {
      const closedSnapshot = await firestore.collection('stores').doc('BkMGoC2HyO5TKFnKjrCY').get();
      const { closed } = closedSnapshot.data();
      setTimestamps(closed);
    } catch (error) {
      console.error(error);
    }
  };

  const classes = useStyles();

  const columns = [
    { field: 'closed', headerName: 'Datum', width: 300 },
  ];

  const rows = timestamps.map((timestamp, index) => {
    const row = {
      id: index,
      closed: timestamp.toDate()
    };
    return row;
  })

  return (
    <div style={{ textAlign: 'left' }}>

      <Typography component='h1' variant='h5' color='primary' style={{ textAlign: 'left', marginBottom: 30 }}>Röda dagar</Typography>

      <Button
        variant='outlined'
        color="primary"
        style={{ marginTop: 9, marginLeft: 20, }}
        // onClick={() => history.push('/kunder/ny')}
        startIcon={<AddIcon />}
      >
        Lägg till datum
      </Button>

      <Paper className={classes.paper}>
        <div style={{ height: 400, width: '100%' }} className={classes.root}>
          <DataGrid columns={columns} rows={rows} pageSize={10} checkboxSelection />
        </div>
      </Paper>

    </div>
  );
}

export default ClosedDays;
